// --
import React from 'react';
import AbstractReactComponent from "../AbstractReactComponent";
import "./ContentPagination.scss";
import Icon from "../icon/FAIcon";
import {Button} from "reactstrap";

export default class ContentPagination extends AbstractReactComponent {
    static propTypes = {
        prev: React.PropTypes.bool, // je aktivní tlačítko - přechozí
        next: React.PropTypes.bool, // je aktivní tlačítko - následující
        onNext: React.PropTypes.func,
        onPrev: React.PropTypes.func,
    };

    render() {
        const {onPrev, onNext, prev, next, children} = this.props;

        return <div className="content-pagination">
            <div className={"content-pagination-left mr-2" + (prev ? "" : " disabled")}>
                <Button disabled={!prev} onClick={onPrev} color="action">
                    <Icon icon="chevron-left"/>
                </Button>
            </div>
            <div className="content-pagination-center">
                {children}
            </div>
            <div className={"content-pagination-right ml-2" + (next ? "" : " disabled")}>
                <Button disabled={!next} onClick={onNext} color="action">
                    <Icon icon="chevron-right"/>
                </Button>
            </div>
        </div>;
    }
}
